<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/PengaturanIzin">Izin Absensi</a></li>
                                <li class="breadcrumb-item active">Pengaturan Izin Absensi</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Izin Absensi</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label>Nama Personil<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Jenis Keperluan<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="status" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedstatus" @update:modelValue="onstatusChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                        </div>
                                        <div class="col-sm-12" v-if="selectedstatus == 4">
                                            <label>Tujuan<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="tujuan" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedtujuan" @update:modelValue="ontujuanChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Dari Tanggal <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm"
                                                    id="dari_tanggal" name="dari_tanggal" placeholder="Dari Tanggal "
                                                    v-model="dari_tanggal">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Sampai Tanggal <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm"
                                                    id="sampai_tanggal" name="sampai_tanggal"
                                                    placeholder="Sampai Tanggal " v-model="sampai_tanggal">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Keterangan</label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="keterangan"
                                                        style="height: 25vh;"></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-6 float-left">
                                            <label>Persetujuan</label>
                                            <div class="form-group clearfix">
                                                <div class="icheck-primary d-inline">
                                                    <input type="checkbox" id="checkboxPrimary1"
                                                        :checked="is_approved == 1">
                                                    <label for="checkboxPrimary1">
                                                        Disetujui
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah')" data-toggle="tooltip"
                                        data-placement="left" title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i> Batal</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            &nbsp;
                        </div>
                        <div class="col-sm-12">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            project_id: process.env.VUE_APP_PROJECT_ID,
            showPassword: false,
            validasi: false,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            dleveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelkabkot: JSON.parse(localStorage.getItem("bdlsistem")),
            levelkelurahan: JSON.parse(localStorage.getItem("sbdsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            datapesan: '',
            dari_tanggal: '',
            sampai_tanggal: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: '',
            status: [],
            datastatus: [],
            defaultSelectedstatus: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedstatus: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: '',

            tujuan: [],
            datatujuan: [],
            defaultSelectedtujuan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedtujuan: '',
            keterangan: '',
            is_approved: '0',
        }
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onstatusChange(a) {
            try {
                this.selectedstatus = this.status[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ontujuanChange(a) {
            try {
                this.selectedtujuan = this.tujuan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/PengaturanIzin");
        },
        async AmbilData() {
            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("settingabsensi-GetDataUser?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    if (this.datapesan == 'success') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("PersetujuanIzin-Master?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus = [];
                        this.status = [];
                        this.datastatus = Response.data.content.data;
                        this.datastatus.forEach((item) => {
                            this.status.push({
                                label: item.nama,
                                code: this.datastatus.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.status.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("PersetujuanIzin-Tujuan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datatujuan = [];
                        this.tujuan = [];
                        this.datatujuan = Response.data.content.data;
                        this.datatujuan.forEach((item) => {
                            this.tujuan.push({
                                label: item.nama,
                                code: this.datatujuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.tujuan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("PersetujuanIzin-ByID?kode=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.selectedid_user = Response.data.content.data[0].id_user;
                    this.selectedstatus = Response.data.content.data[0].izin;
                    this.dari_tanggal = Response.data.content.data[0].dari_tanggal;
                    this.sampai_tanggal = Response.data.content.data[0].sampai_tanggal;
                    this.selectedtujuan = Response.data.content.data[0].tujuan;
                    this.keterangan = this.Dekriptext(Response.data.content.data[0].keterangan);
                    this.is_approved = Response.data.content.data[0].is_approved;
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("settingabsensi-GetDataUser?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    if (this.datapesan == 'success') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.id,
                            });

                            if (item.id == this.selectedid_user) {
                                this.defaultSelectedid_user = {
                                    code: this.dataid_user.indexOf(item) + 1,
                                    label: item.nama, 
                                    tag: item.id 
                                };
                            }
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("PersetujuanIzin-Master?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus = [];
                        this.status = [];
                        this.datastatus = Response.data.content.data;
                        this.datastatus.forEach((item) => {
                            this.status.push({
                                label: item.nama,
                                code: this.datastatus.indexOf(item) + 1,
                                tag: item.id,
                            });

                            if (item.id == this.selectedstatus) {
                                this.defaultSelectedstatus = {
                                    code: this.datastatus.indexOf(item) + 1,
                                    label: item.nama, 
                                    tag: item.id 
                                };
                            }
                        });
                        this.status.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("PersetujuanIzin-Tujuan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datatujuan = [];
                        this.tujuan = [];
                        this.datatujuan = Response.data.content.data;
                        this.datatujuan.forEach((item) => {
                            this.tujuan.push({
                                label: item.nama,
                                code: this.datatujuan.indexOf(item) + 1,
                                tag: item.id,
                            });

                            if (item.id == this.selectedtujuan) {
                                this.defaultSelectedtujuan = {
                                    code: this.datatujuan.indexOf(item) + 1,
                                    label: item.nama, 
                                    tag: item.id 
                                };
                            }
                        });
                        this.tujuan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        validasidata() {
            if ((this.selectedid_user == '') || (this.selectedid_user == undefined) || (this.selectedid_user == null) || (this.selectedid_user == 'null')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Personil',
                });
                return false;
            }
            if ((this.selectedstatus == '') || (this.selectedstatus == undefined) || (this.selectedstatus == null) || (this.selectedstatus == 'null')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Jenis Keperluan',
                });
                return false;
            }
            if ((document.getElementById('dari_tanggal').value == '') || (document.getElementById('dari_tanggal').value == '0000-00-00') || (document.getElementById('dari_tanggal').value == null)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Tanggal Mulai',
                });
                document.getElementById('dari_tanggal').focus();
                return false;
            }
            if ((document.getElementById('sampai_tanggal').value == '') || (document.getElementById('sampai_tanggal').value == '0000-00-00') || (document.getElementById('sampai_tanggal').value == null)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Tanggal Selesai',
                });
                document.getElementById('sampai_tanggal').focus();
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var is_approved = 0;
            if (document.getElementById('checkboxPrimary1').checked == true) {
                is_approved = 1;
            }
            var fd = new FormData();
            fd.append("id_user", this.selectedid_user);
            fd.append("tujuan", this.selectedtujuan);
            fd.append("dari_tanggal", this.dari_tanggal);
            fd.append("sampai_tanggal", this.sampai_tanggal);
            fd.append("status", this.selectedstatus);
            fd.append("keterangan", this.keterangan);
            fd.append("is_approved", is_approved);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("PersetujuanIzin-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/PengaturanIzin");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var is_approved = 0;
            if (document.getElementById('checkboxPrimary1').checked == true) {
                is_approved = 1;
            }
            var fd = new FormData();
            fd.append("id_user", this.selectedid_user);
            fd.append("tujuan", this.selectedtujuan);
            fd.append("dari_tanggal", this.dari_tanggal);
            fd.append("sampai_tanggal", this.sampai_tanggal);
            fd.append("status", this.selectedstatus);
            fd.append("keterangan", this.keterangan);
            fd.append("is_approved", is_approved);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("PersetujuanIzin-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/PengaturanIzin");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        else {
            this.AmbilData();
        }
    }
}
</script>
<style></style>